<template>
	<NuxtLink v-if="to" :to="to">
		<slot></slot>
	</NuxtLink>
	<component :is="element" v-else>
		<slot></slot>
	</component>
</template>

<script lang="ts" setup>
	/**
	 * Element to conditionally render a NuxtLink or another html element.
	 * If no Route is provided, the element prop is used to render as the given element.
	 */

	import type {PropType} from 'vue';
	import type {RouteLocationRaw} from 'vue-router';

	defineProps({
		to: {
			type: [String, Object] as PropType<RouteLocationRaw>,
			default: null
		},
		element: {
			type: String,
			default: 'div'
		}
	});
</script>
